<div class="component-container">
  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
    <div class="margin-header-align section-heading text-uppercase">
      <div class="ui-g-12">
        <app-section-header
          [title]="'grid-comp.feed-in-management' | translate"
          [tooltip]="'tooltips.technical-data.grid-comp.feed-in-management' | translate"></app-section-header>
      </div>
      <div class="section-buttons">
        <lock-unlock-buttons
          [showLockButton]="isDetailsView"
          [showUnlockButton]="isDetailsView"
          [isLocked]="getSectionLocked()"
          [areButtonsDisabled]="!(isModeratorRole() && editabilityBasedOnProcessStatus.internalRoles)"
          (lockButtonClickedEvent)="lockSection()"
          (unLockButtonClickedEvent)="unlockSection()"></lock-unlock-buttons>
        <i
          *ngIf="isDetailsView"
          class="pi pi-comment"
          [ngClass]="isCommentVisible || getSectionComment() ? 'lock-icon-style' : 'unlock-icon-style'"
          [pTooltip]="showCommentTooltip() ? ('comment-section.comment-tooltip' | translate) : null"
          [tooltipPosition]="showCommentTooltip() ? 'bottom' : null"
          (click)="showComment()"></i>
      </div>
    </div>
  </div>
  <section-comment
    [isCommentTextInputVisible]="isModeratorRole() && (isCommentVisible || getSectionComment())"
    [isCommentTextVisible]="!isModeratorRole()"
    [isCommentSaveVisible]="!getSectionComment()"
    [isCommentDeleteButtonDisabled]="!editabilityBasedOnProcessStatus.internalRoles"
    [comment]="getSectionComment()"
    (saveCommentEvent)="updateComment($event)"
    (deleteCommentEvent)="deleteComment()"></section-comment>
  <div class="section-wrapper margin-align">
    <div class="top-bottom-margin section-column" [ngClass]="getSectionLocked() !== true || !applicationId ? '' : 'disable-section'">
      <div class="section-field" [ngClass]="isSectionDisabled || isNoManagementDisabled ? 'disabled-radio' : ''">
        <p-radioButton
          required
          name="feed_in_management"
          [value]="feedInManagementValues.noManagement"
          [(ngModel)]="technicalData.feed_in_management"></p-radioButton>
        <label class="ml-2" [pTooltip]="noManagementTooltip" tooltipStyleClass="netz-info-tooltip" tooltipPosition="top">
          {{ 'grid-comp.no-feed-in' | translate }}
        </label>
      </div>
      <div class="section-field" [ngClass]="isSectionDisabled || isLimit60PercDisabled ? 'disabled-radio' : ''">
        <p-radioButton
          required
          name="feed_in_management"
          [value]="feedInManagementValues.limit60Perc"
          [(ngModel)]="technicalData.feed_in_management"></p-radioButton>
        <label class="ml-2" [pTooltip]="limit60PercTooltip" tooltipStyleClass="netz-info-tooltip" tooltipPosition="top">
          {{ 'grid-comp.limit-60-perc' | translate }}
        </label>
      </div>
      <div class="section-field" [ngClass]="isSectionDisabled || isLimit60PercPowerAndControllabilityDisabled ? 'disabled-radio' : ''">
        <p-radioButton
          required
          name="feed_in_management"
          [value]="feedInManagementValues.limit60PercPowerAndControl"
          [(ngModel)]="technicalData.feed_in_management"></p-radioButton>
        <label
          class="ml-2"
          [pTooltip]="limit60PercPowerAndControllabilityTooltip"
          tooltipStyleClass="netz-info-tooltip"
          tooltipPosition="top">
          {{ 'grid-comp.limit-60-perc-power-and-controllability' | translate }}
        </label>
      </div>
      <div class="section-field" [ngClass]="isSectionDisabled || isControlViaRadioDisabled ? 'disabled-radio' : ''">
        <p-radioButton
          required
          name="feed_in_management"
          [value]="feedInManagementValues.controlViaRadio"
          [(ngModel)]="technicalData.feed_in_management"></p-radioButton>
        <label class="ml-2" [pTooltip]="controlViaRadioTooltip" tooltipStyleClass="netz-info-tooltip" tooltipPosition="top">
          {{ 'grid-comp.control-via-radio' | translate }}
        </label>
      </div>
      <div class="section-field" [ngClass]="isSectionDisabled || isControlViaControlUnitDisabled ? 'disabled-radio' : ''">
        <p-radioButton
          required
          name="feed_in_management"
          [value]="feedInManagementValues.controlViaControlUnit"
          [(ngModel)]="technicalData.feed_in_management"></p-radioButton>
        <label class="ml-2" [pTooltip]="controlViaControlUnitTooltip" tooltipStyleClass="netz-info-tooltip" tooltipPosition="top">
          {{ 'grid-comp.control-via-control-unit' | translate }}
        </label>
      </div>
    </div>
  </div>
</div>
